package com.anjuros.website.redesign.sections.seo

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.redesign.components.RdSection
import com.anjuros.website.redesign.components.RdSectionHead
import com.anjuros.website.redesign.styles.RdH3Style
import com.anjuros.website.redesign.styles.SeoChecklistStyle
import com.anjuros.website.redesign.styles.SeoTickStyle
import com.anjuros.website.redesign.util.RdIcons
import com.anjuros.website.redesign.util.RdText
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.Ul

private val Checklist = listOf(
    RdText.SEO_CHECK1_TITLE to RdText.SEO_CHECK1_TEXT,
    RdText.SEO_CHECK2_TITLE to RdText.SEO_CHECK2_TEXT,
    RdText.SEO_CHECK3_TITLE to RdText.SEO_CHECK3_TEXT,
    RdText.SEO_CHECK4_TITLE to RdText.SEO_CHECK4_TEXT,
    RdText.SEO_CHECK5_TITLE to RdText.SEO_CHECK5_TEXT,
    RdText.SEO_CHECK6_TITLE to RdText.SEO_CHECK6_TEXT,
    RdText.SEO_CHECK7_TITLE to RdText.SEO_CHECK7_TEXT,
    RdText.SEO_CHECK8_TITLE to RdText.SEO_CHECK8_TEXT,
)

/** The SEO setup every website gets, as a ticked checklist. */
@Composable
fun SeoIncludedSection() {
    RdSection(id = "included", labelledBy = "inc-h") {
        RdSectionHead(RdText.SEO_INCLUDED_EYEBROW, "inc-h", RdText.SEO_INCLUDED_TITLE, RdText.SEO_INCLUDED_LEDE)
        Ul(SeoChecklistStyle.toModifier().toAttrs()) {
            Checklist.forEach { (title, text) ->
                Li {
                    Span(SeoTickStyle.toModifier().toAttrs()) { RdIcons.Check(size = 16) }
                    Div {
                        H3(RdH3Style.toModifier().toAttrs()) { Text(LocalText(title)) }
                        P { Text(LocalText(text)) }
                    }
                }
            }
        }
    }
}
